(function () {
  if (!window.EGEBEYI_CUSTOMER || !window.egebeyiCustomer) return;

  function isAddressForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    var action = form.getAttribute('action') || form.action || '';
    return /\/account\/addresses(\/|\?|$)/.test(action);
  }

  function stripBrackets(s) {
    return (s || '')
      .replace(/\s*\[Fatura:[^\]]*\]/g, '')
      .replace(/\s*\[Konum:[^\]]*\]/g, '')
      .trim();
  }

  function isManualSelection(selectEl, value) {
    if (!selectEl || !value) return false;
    var opts = Array.from(selectEl.options);
    var match = opts.find(function (o) { return o.value === value; });
    return !!(match && match.dataset.manual === 'true');
  }

  function collectExtras(form) {
    var fd = new FormData(form);
    var typeInput = form.querySelector('[data-invoice-type-input]');
    var fatura_turu = typeInput ? (typeInput.value || 'Bireysel') : '';
    var firma_adi = (fd.get('address[firma_adi]') || '').toString().trim();
    var vkn = (fd.get('address[vkn]') || '').toString().trim();
    var vd = (fd.get('address[vergi_dairesi]') || '').toString().trim();
    var eFaturaInput = form.querySelector('[name="address[e_fatura]"]');
    var e_fatura = !!(eFaturaInput && eFaturaInput.checked);

    var country = (fd.get('address[country]') || '').toString().toLowerCase();
    var isTR = country === 'turkey' || country === 'türkiye' || country === 'tr';
    var trProv = form.querySelector('[data-tr-province-select]');
    var trDist = form.querySelector('[data-tr-district-select]');
    var trNeigh = form.querySelector('[data-tr-neighborhood-select]');
    var il = isTR && trProv ? (trProv.value || '').trim() : '';
    var ilce = isTR && trDist ? (trDist.value || '').trim() : '';
    var mahalle = isTR && trNeigh ? (trNeigh.value || '').trim() : '';

    var out = {};
    if (fatura_turu) out.fatura_turu = fatura_turu;
    if (fatura_turu === 'Kurumsal') {
      if (firma_adi) out.firma_adi = firma_adi;
      if (vkn) out.vkn = vkn;
      if (vd) out.vd = vd;
      out.e_fatura = e_fatura;
    }
    if (il) {
      out.il = il;
      if (isManualSelection(trProv, il)) out.il_manual = true;
    }
    if (ilce) {
      out.ilce = ilce;
      if (isManualSelection(trDist, ilce)) out.ilce_manual = true;
    }
    if (mahalle) {
      out.mahalle = mahalle;
      if (isManualSelection(trNeigh, mahalle)) out.mahalle_manual = true;
    }
    return out;
  }

  function readAddressFromForm(form) {
    var fd = new FormData(form);
    return {
      first_name: (fd.get('address[first_name]') || '').toString().trim(),
      last_name: (fd.get('address[last_name]') || '').toString().trim(),
      company: (fd.get('address[company]') || '').toString().trim(),
      address1: stripBrackets(fd.get('address[address1]') || ''),
      address2: stripBrackets(fd.get('address[address2]') || ''),
      city: (fd.get('address[city]') || '').toString().trim(),
      province: (fd.get('address[province]') || '').toString().trim(),
      country: (fd.get('address[country]') || 'TR').toString().trim(),
      zip: (fd.get('address[zip]') || '').toString().trim(),
      phone: (fd.get('address[phone]') || '').toString().trim(),
      extras: collectExtras(form),
      _is_default: fd.get('address[default]') === '1',
    };
  }

  function extractAddressId(urlOrAction) {
    var m = (urlOrAction || '').match(/\/addresses\/(\d+)/);
    return m ? parseInt(m[1], 10) : null;
  }

  function showError(form, message) {
    var existing = form.querySelector('[data-egebeyi-api-msg]');
    if (existing) existing.remove();
    var div = document.createElement('div');
    div.setAttribute('data-egebeyi-api-msg', '');
    div.style.cssText = 'margin-top:1rem;padding:.8rem 1rem;border-radius:.5rem;background:#fdecea;color:#a8201a;font-size:1.3rem;';
    div.textContent = message;
    form.appendChild(div);
  }

  function injectStyles() {
    if (document.getElementById('egebeyi-confirm-styles')) return;
    var s = document.createElement('style');
    s.id = 'egebeyi-confirm-styles';
    s.textContent = [
      '.egebeyi-confirm{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;font-family:system-ui,sans-serif;}',
      '.egebeyi-confirm[hidden]{display:none !important;}',
      '.egebeyi-confirm__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.55);}',
      '.egebeyi-confirm__panel{position:relative;background:#fff;padding:2.4rem;border-radius:1.2rem;max-width:38rem;width:90%;box-shadow:0 1.2rem 3.6rem rgba(0,0,0,.25);text-align:center;}',
      '.egebeyi-confirm__title{margin:0 0 .8rem;font-size:1.7rem;font-weight:600;color:#111;}',
      '.egebeyi-confirm__msg{margin:0 0 2rem;font-size:1.4rem;color:#444;line-height:1.5;}',
      '.egebeyi-confirm__actions{display:flex;gap:.8rem;justify-content:center;}',
      '.egebeyi-confirm__btn{flex:1;padding:1.1rem 1.6rem;border:0;border-radius:.7rem;font-size:1.4rem;font-weight:600;cursor:pointer;font-family:inherit;}',
      '.egebeyi-confirm__btn--cancel{background:#eee;color:#333;}',
      '.egebeyi-confirm__btn--cancel:hover{background:#e2e2e2;}',
      '.egebeyi-confirm__btn--ok{background:#a8201a;color:#fff;}',
      '.egebeyi-confirm__btn--ok:hover{background:#8c1a15;}',
      '.egebeyi-confirm__btn:disabled{opacity:.6;cursor:not-allowed;}',
    ].join('');
    document.head.appendChild(s);
  }

  function egebeyiConfirm(message, opts) {
    opts = opts || {};
    injectStyles();
    return new Promise(function (resolve) {
      var modal = document.createElement('div');
      modal.className = 'egebeyi-confirm';
      var actions = opts.alertOnly
        ? '<button type="button" class="egebeyi-confirm__btn egebeyi-confirm__btn--cancel" style="background:#000;color:#fff;">' + (opts.okText || 'Tamam') + '</button>'
        : '<button type="button" class="egebeyi-confirm__btn egebeyi-confirm__btn--cancel">' + (opts.cancelText || 'Vazgeç') + '</button>'
        + '<button type="button" class="egebeyi-confirm__btn egebeyi-confirm__btn--ok">' + (opts.okText || 'Sil') + '</button>';
      modal.innerHTML = ''
        + '<div class="egebeyi-confirm__backdrop"></div>'
        + '<div class="egebeyi-confirm__panel" role="dialog" aria-modal="true">'
        +   (opts.title ? '<h3 class="egebeyi-confirm__title">' + opts.title + '</h3>' : '')
        +   '<p class="egebeyi-confirm__msg"></p>'
        +   '<div class="egebeyi-confirm__actions">' + actions + '</div>'
        + '</div>';
      modal.querySelector('.egebeyi-confirm__msg').textContent = message;
      document.body.appendChild(modal);

      function close(result) {
        document.removeEventListener('keydown', onKey);
        modal.remove();
        resolve(result);
      }
      function onKey(e) {
        if (e.key === 'Escape') close(false);
        if (e.key === 'Enter') close(opts.alertOnly ? false : true);
      }
      modal.querySelector('.egebeyi-confirm__btn--cancel').addEventListener('click', function () { close(false); });
      var okBtn = modal.querySelector('.egebeyi-confirm__btn--ok');
      if (okBtn) okBtn.addEventListener('click', function () { close(true); });
      modal.querySelector('.egebeyi-confirm__backdrop').addEventListener('click', function () { close(false); });
      document.addEventListener('keydown', onKey);
      setTimeout(function () { (okBtn || modal.querySelector('.egebeyi-confirm__btn--cancel')).focus(); }, 50);
    });
  }

  // SUBMIT interceptor — bubble phase, runs AFTER existing listeners
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isAddressForm(form)) return;

    e.preventDefault();
    e.stopPropagation();

    var btn = form.querySelector('button[type="submit"]');
    var origText = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Kaydediliyor...'; }

    var data = readAddressFromForm(form);
    var setDefault = data._is_default;
    delete data._is_default;

    var addrId = extractAddressId(form.getAttribute('action') || form.action);

    var op;
    if (addrId) {
      op = window.egebeyiCustomer.updateAddress(addrId, data).then(function (res) {
        if (setDefault) return window.egebeyiCustomer.setDefaultAddress(addrId);
        return res;
      });
    } else {
      op = window.egebeyiCustomer.createAddress(data).then(function (res) {
        var newId = res && res.address && res.address.id;
        if (setDefault && newId) return window.egebeyiCustomer.setDefaultAddress(newId);
        return res;
      });
    }

    op.then(function () {
      window.location.reload();
    }).catch(function (err) {
      if (btn) { btn.disabled = false; btn.innerHTML = origText; }
      showError(form, 'Bir hata oluştu: ' + (err && err.message ? err.message : 'bilinmiyor'));
    });
  }, false);

  // DELETE interceptor — capture phase, runs BEFORE customer.js handler
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-confirm-message]');
    if (!btn) return;
    var addrId = parseInt(btn.dataset.addressId || '0', 10) || extractAddressId(btn.dataset.target || '');
    if (!addrId) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var msg = btn.dataset.confirmMessage || 'Bu adresi silmek istediğinden emin misin?';
    egebeyiConfirm(msg, { title: 'Adres Sil', okText: 'Sil', cancelText: 'Vazgeç' }).then(function (ok) {
      if (!ok) return;

      btn.disabled = true;
      var origText = btn.innerHTML;
      btn.innerHTML = 'Siliniyor...';

      window.egebeyiCustomer.deleteAddress(addrId).then(function () {
        window.location.reload();
      }).catch(function (err) {
        btn.disabled = false;
        btn.innerHTML = origText;
        var raw = err && err.message ? err.message : '';
        var friendly = raw;
        if (/default address/i.test(raw)) {
          friendly = 'Varsayılan adres silinemez. Önce başka bir adresi varsayılan olarak işaretle, sonra bu adresi silebilirsin.';
        } else if (/Not Found/i.test(raw)) {
          friendly = 'Adres bulunamadı. Sayfayı yenilemeyi dene.';
        } else {
          friendly = 'Adres silinemedi: ' + raw;
        }
        egebeyiConfirm(friendly, { title: 'Silme Başarısız', alertOnly: true, okText: 'Tamam' });
      });
    });
  }, true);
})();
